import React, { createContext, useContext, useCallback } from 'react';
import useApiService from './ApiService';
import CONFIG from './CONFIG';

const NotificationApiContext = createContext(null);

export function NotificationApiProvider({ children }) {
  const { get, post, put, del } = useApiService(CONFIG.SERVER_ASSISTANT);

  const getNotifications = useCallback(
    async (skip, limit) => {
      if (!skip) {
        skip = 0;
      }
      if (!limit) {
        limit = 10;
      }
      try {
        const response = await get(`/v1/notifications?skip=${skip}&limit=${limit}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching notifications:', error);
        throw error;
      }
    },
    [get],
  );

  const getNotificationById = useCallback(
    async (notificationId) => {
      try {
        const response = await get(`/v1/notifications/${notificationId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching notification by ID:', error);
        throw error;
      }
    },
    [get],
  );

  const createNotification = useCallback(
    async (notification) => {
      try {
        const response = await put(`/v1/notifications`, notification);
        return response.data;
      } catch (error) {
        console.error('Error creating notification:', error);
        throw error;
      }
    },
    [put],
  );

  const updateNotificationById = useCallback(
    async (notificationId, notification) => {
      try {
        const response = await put(`/v1/notifications/${notificationId}`, notification);
        return response.data;
      } catch (error) {
        console.error('Error updating notification:', error);
        throw error;
      }
    },
    [put],
  );

  const deleteNotification = useCallback(
    async (notificationId) => {
      try {
        const response = await del(`/v1/notifications/${notificationId}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting notification:', error);
        throw error;
      }
    },
    [del],
  );

  const sendTestNotification = useCallback(
    async (notification) => {
      try {
        const response = await post(`/v1/notifications`, notification);
        return response.data;
      } catch (error) {
        console.error('Error sending test notification:', error);
        throw error;
      }
    },
    [post],
  );

  return (
    <NotificationApiContext.Provider
      value={{
        getNotifications,
        getNotificationById,
        createNotification,
        updateNotificationById,
        deleteNotification,
        sendTestNotification,
      }}
    >
      {children}
    </NotificationApiContext.Provider>
  );
}

export function useNotificationApi() {
  const context = useContext(NotificationApiContext);
  if (!context) {
    throw new Error('useNotificationApi must be used within a NotificationApiProvider');
  }
  return context;
}
